import React, { useState, useEffect } from "react";
import axios from "axios";

import Header from "./Header2";

import "./Research_rihes_detail_th.css";

const Research_rihes_detail_th = () => {
  const xURL = "https://research.rihes.cmu.ac.th/api/";

  const [researcher, setResearcher] = useState(null);
  const [publications, setPublications] = useState([]);
  const [headProjects, setHeadProjects] = useState([]);
  const [patents, setPatents] = useState([]);
  const [awards, setAwards] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeMenu, setActiveMenu] = useState(1);

  const [enlargedImage, setEnlargedImage] = useState(null);

  const MENU_ITEMS = [
    {
      id: 1,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 1024 1024"
        >
          <path d="M0 0h1024v1024H0z" fill="none" />
          <path
            fill="currentColor"
            d="m908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5c-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1l-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2c17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9l183.7-179.1c5-4.9 8.3-11.3 9.3-18.3c2.7-17.5-9.5-33.7-27-36.3"
          />
        </svg>
      ),
      label: "Research Highlight",
      labelEn: "Research Highlight"
    },
    {
      id: 2,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 512 512"
        >
          <path d="M0 0h512v512H0z" fill="none" />
          <path
            fill="currentColor"
            d="M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208m-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24m80-96v160c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24m80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24s-24 10.7-24 24"
          />
        </svg>
      ),
      label: "Field of Research",
      labelEn: "Field of Research"
    },
    {
      id: 3,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 512 512"
        >
          <path d="M0 0h512v512H0z" fill="none" />
          <path
            fill="currentColor"
            d="M41 66.91V415.8c86.5 1 147.5 14.8 206 29.3V141.4c-45.3-30.1-90.4-58.75-206-74.49m430 0C355.4 82.65 310.3 111.3 265 141.4v303.7c58.5-14.5 119.5-28.3 206-29.3zm-20.9 26.6l.8 66.99c-59.4 17.6-114.5 37.9-168.9 56c-.4-20.9-.7-41.7-1.1-62.6c52.8-29.2 111.2-48.1 169.2-60.39M69.01 105.3C129.8 119.4 184.1 136 226.1 150.1l.2 19c-41.6-13.9-101.3-32.3-161.35-46.3zm.12 46.6l35.97 6.5l-3.2 17.8l-35.97-6.5zm54.17 11.3l32.5 6.2l-3.4 17.6l-32.5-6.2zm53.2 10.5l49.6 9.6l-3.4 17.6l-49.6-9.6zm263.1 19.9l5.2 17.2l-56 16.9l-5.2-17.2zm-377.68 4.7C119.2 205 176 212.2 223.8 225l-4.6 17.4c-46-12.4-102.2-19.6-159.38-26.3zM357.1 216l4.8 17.4l-71.7 19.8l-4.8-17.4zm86.4 21l4.8 17.4l-32.8 9.1l-4.8-17.4zm-378.3 1.6l49.9 5.2l-2 18l-49.8-5.4zm76.9 9.8l82.1 12.3l-2.6 17.8l-82.1-12.3zm248.5 3.7l4.8 17.4L288.5 299l-4.8-17.4zm55.8 22.9l4.6 17.4L348.5 319l-4.6-17.4zm-388.06 6.4c29.84 3.1 61.96 7.5 84.46 13v111L59.2 398c-.33-38.9-.48-77.7-.86-116.6m104.56 14.7l61.5 7.5l-2.2 17.8l-61.5-7.5zm161.5 11.8l4.2 17.5l-37.8 9.1l-4.2-17.5zm129.1 4.1l.4 82.2l-78.5 10.2c-.3-23.8-.4-47.7-.7-71.5zM164 334.4l59.8 9.8l-3 17.8l-59.8-9.8zm271.7 1l-42.8 11.3l.3 37.3l42.7-5.6zm-81.4 9.8l3.4 17.6l-68.9 13.1l-3.4-17.6zm-191.1 29.1l62.6 12.4l-3.4 17.6l-62.6-12.4zm186.6 6.8l4 17.6l-62.5 13.9l-4-17.6z"
          />
        </svg>
      ),
      label: "Publication",
      labelEn: "Publication"
    },
    {
      id: 4,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 1024 1024"
        >
          <path d="M0 0h1024v1024H0z" fill="none" />
          <path
            fill="currentColor"
            d="M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12c0-17.7-14.3-32-32-32m-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748z"
          />
        </svg>
      ),
      label: "Projects",
      labelEn: "Projects"
    },
    {
      id: 5,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            d="M20 15c-1 1 1.25 3.75 0 5s-4-1-5 0s-1.5 3-3 3s-2-2-3-3s-3.75 1.25-5 0s1-4 0-5s-3-1.5-3-3s2-2 3-3s-1.25-3.75 0-5s4 1 5 0s1.5-3 3-3s2 2 3 3s3.75-1.25 5 0s-1 4 0 5s3 1.5 3 3s-2 2-3 3ZM7 12l3 3l7-7"
          />
        </svg>
      ),
      label: "Patent",
      labelEn: "Patent"
    },
    {
      id: 6,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 512 512"
        >
          <path d="M0 0h512v512H0z" fill="none" />
          <path
            fill="currentColor"
            d="M98.398 21.146a17 17 0 0 0-4.636.521c-20.49 5.262-33.163 20.63-36.116 38.649c-2.952 18.019 2.168 38.346 12.676 58.193c20.695 39.086 63.262 77.08 117.852 85.85c-5.61-6.72-11.05-14.246-16.274-22.375c-39.008-12.57-70.021-42.344-85.67-71.899c-9.206-17.387-12.846-34.491-10.82-46.857C77.437 50.862 83.482 42.89 98.238 39.1c.065-.017.068-.034.092-.053c-.065-.143.105-.08 0 0a.7.7 0 0 0 .176.217c.527.493 1.689 2.24 2.207 5.14c1.036 5.804-.413 15.593-8.135 25.68l14.293 10.942c10.418-13.61 13.65-28.086 11.56-39.785c-1.044-5.85-3.396-11.165-7.628-15.124c-3.174-2.969-7.747-4.868-12.405-4.972zm315.204 0c-4.658.104-9.23 2.003-12.405 4.972c-4.232 3.96-6.584 9.274-7.629 15.124c-2.089 11.699 1.143 26.174 11.56 39.785l14.294-10.942c-7.722-10.087-9.171-19.876-8.135-25.68c.518-2.9 1.68-4.647 2.207-5.14a.7.7 0 0 0 .176-.217c-.105-.08.065-.143 0 0c.024.019.027.036.092.053c14.756 3.79 20.801 11.76 22.828 24.127c2.026 12.366-1.614 29.47-10.82 46.857c-15.649 29.555-46.662 59.33-85.67 71.899c-5.223 8.129-10.665 15.655-16.274 22.375c54.59-8.77 97.157-46.764 117.852-85.85c10.508-19.847 15.628-40.174 12.676-58.193c-2.953-18.02-15.626-33.387-36.116-38.649a17 17 0 0 0-4.636-.521m-276.166 7.713c2.146 36.533 16.76 83.07 36.537 120.824c10.707 20.442 22.876 38.334 34.761 50.685C220.62 212.72 232 218.858 240 218.858h32c8 0 19.38-6.138 31.266-18.49s24.054-30.243 34.761-50.685c19.777-37.755 34.39-84.29 36.537-120.824zm95.564 208v16h46v-16zm6.445 34c-2.458 25.967-12.796 57.873-24.437 76h81.984c-11.64-18.127-21.979-50.033-24.437-76zm-38.445 94v14h110v-14zm-32 32v94h174v-94zm23 23h128v48H192z"
          />
        </svg>
      ),
      label: "Awards",
      labelEn: "Awards"
    }
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // ====== Helper Functions ======
  const countDistinctRows = data => {
    if (!data || data.length === 0) return 0;
    let count = 0;
    for (let i = 0; i < data.length; i++) {
      if (i === 0 || data[i].name_thai !== data[i - 1].name_thai) {
        count++;
      }
    }
    return count;
  };

  const getHeadProjectPages = (data, itemsPerPage) => {
    if (!data || data.length === 0) return [];

    const pages = [];
    let startIdx = 0;

    while (startIdx < data.length) {
      let endIdx = startIdx;

      // เพิ่มข้อมูลเป็นชุดโครงการเสมอ จึงไม่มีโครงการถูกตัดกลาง rowSpan
      while (endIdx < data.length) {
        const projectName = data[endIdx].name_thai;
        let projectEndIdx = endIdx + 1;

        // หาจุดสิ้นสุดของโครงการปัจจุบัน
        while (
          projectEndIdx < data.length &&
          data[projectEndIdx].name_thai === projectName
        ) {
          projectEndIdx++;
        }

        // เพิ่มทั้งโครงการลงในหน้าปัจจุบัน
        endIdx = projectEndIdx;

        // ครบ/เกิน 10 แถวแล้ว จบหน้านี้
        if (endIdx - startIdx >= itemsPerPage) {
          break;
        }
      }

      pages.push({
        data: data.slice(startIdx, endIdx),
        startIdx
      });

      // หน้าถัดไปเริ่มต่อจากข้อมูลจริงที่จบในหน้านี้
      startIdx = endIdx;
    }

    return pages;
  };

  const totalPages = publications
    ? Math.ceil(publications.length / itemsPerPage)
    : 0;
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const currentPublications = publications
    ? publications.slice(startIdx, endIdx)
    : [];

  const headProjectPages = getHeadProjectPages(headProjects, itemsPerPage);

  const totalPages2 = headProjectPages.length || 1;

  const currentHeadProjectPage = headProjectPages[currentPage - 1] || {
    data: [],
    startIdx: 0
  };

  const currentHeadProjects = currentHeadProjectPage.data;
  const headProjectsStartIdx = currentHeadProjectPage.startIdx;

  const totalPages3 = patents ? Math.ceil(patents.length / itemsPerPage) : 0;
  const currentPatents = patents ? patents.slice(startIdx, endIdx) : [];

  const totalPages4 = awards ? Math.ceil(awards.length / itemsPerPage) : 0;
  const currentAwards = awards ? awards.slice(startIdx, endIdx) : [];

  useEffect(() => {
    // ดึง researcher id จาก URL parameter
    const params = new URLSearchParams(window.location.search);
    const researcherId = params.get("rid");

    if (researcherId) {
      fetchResearcherDetail(researcherId);
      fetchResearcherPublications(researcherId);
      fetchResearcherHeadProjects(researcherId);
      fetchResearcherPatents(researcherId);
      fetchResearcherAwards(researcherId);
    }
  }, []);

  const fetchResearcherDetail = async id => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${xURL}getResearch_rihes_detail_th`,
        { rid: id } // ส่ง id เป็น parameter
      );
      if (response.data && response.data.length > 0) {
        setResearcher(response.data[0]);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err.message || "เกิดข้อผิดพลาดในการดึงข้อมูล");
    } finally {
      setLoading(false);
    }
  };

  const fetchResearcherPublications = async id => {
    try {
      const response = await axios.post(`${xURL}getResearch_scopus`, {
        rid: id
      });
      if (response.data) {
        setPublications(response.data);
      }
    } catch (err) {
      console.error("Error fetching publications:", err);
    }
  };

  const fetchResearcherHeadProjects = async id => {
    try {
      const response = await axios.post(`${xURL}getResearch_head_project`, {
        rid: id
      });
      if (response.data) {
        setHeadProjects(response.data);
      }
    } catch (err) {
      console.error("Error fetching head projects:", err);
    }
  };

  const fetchResearcherPatents = async id => {
    try {
      const response = await axios.post(`${xURL}getResearch_patent`, {
        rid: id,
        lang: "th"
      });
      if (response.data) {
        setPatents(response.data);
      }
    } catch (err) {
      console.error("Error fetching patents:", err);
    }
  };

  const fetchResearcherAwards = async id => {
    try {
      const response = await axios.post(`${xURL}getResearch_award`, {
        rid: id,
        lang: "th"
      });
      if (response.data) {
        setAwards(response.data);
      }
    } catch (err) {
      console.error("Error fetching awards:", err);
    }
  };

  if (loading)
    return (
      <div className="research-rihes-detail-th">
        <p>กำลังโหลด...</p>
      </div>
    );
  if (error)
    return (
      <div className="research-rihes-detail-th">
        <p>
          เกิดข้อผิดพลาด: {error}
        </p>
      </div>
    );
  if (!researcher)
    return (
      <div className="research-rihes-detail-th">
        <p>ไม่พบข้อมูล</p>
      </div>
    );

  // คำนวณจำนวนแถวที่ shouldRender เป็น true ที่ผ่านมา
  const countPreviousRows = (data, currentStartIdx) => {
    let count = 0;
    for (let i = 0; i < currentStartIdx; i++) {
      if (i === 0 || data[i].name_thai !== data[i - 1].name_thai) {
        count++;
      }
    }
    return count;
  };

  const getStatusStyle = statusCode => {
    const statusMap = {
      P: {
        label: "ยื่นข้อเสนอโครงการ",
        color: "#FFA500",
        bgColor: "#fff3e0",
        icon: "📋"
      },
      I: {
        label: "อยู่ระหว่างดำเนินการ",
        color: "#2196F3",
        bgColor: "#e3f2fd",
        icon: "⚙️"
      },
      C: {
        label: "เสร็จสิ้นแล้ว",
        color: "#4CAF50",
        bgColor: "#e8f5e9",
        icon: "✓"
      },
      F: {
        label: "ไม่ได้รับอนุมัติ",
        color: "#F44336",
        bgColor: "#ffebee",
        icon: "✗"
      },
      S: {
        label: "ยกเลิกโครงการ",
        color: "#9C27B0",
        bgColor: "#f3e5f5",
        icon: "⏹"
      },
      "C*": {
        label: "เสร็จสิ้นแล้ว",
        color: "#4CAF50",
        bgColor: "#e8f5e9",
        icon: "✓"
      }
      //  "C*": {
      //     label: "ปิดแบบมีเงื่อนไข",
      //     color: "#FF6F00",
      //     bgColor: "#ffe0b2",
      //     icon: "⚠️"
      //   }
    };

    return (
      statusMap[statusCode] || {
        label: statusCode || "-",
        color: "#666",
        bgColor: "#f5f5f5",
        icon: "•"
      }
    );
  };

  const getPatentType = patentType => {
    const typeMap = {
      1: "อนุสิทธิบัตร",
      2: "สิทธิบัตร"
    };
    return typeMap[patentType] || patentType || "-";
  };

  // const countDistinctRows = data => {
  //   if (!data || data.length === 0) return 0;
  //   let count = 0;
  //   for (let i = 0; i < data.length; i++) {
  //     if (i === 0 || data[i].name_thai !== data[i - 1].name_thai) {
  //       count++;
  //     }
  //   }
  //   return count;
  // };

  const formatDateDDMMYYYY = dateStr => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr; // fallback if not a valid date
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  return (
    <div className="research-rihes-detail-th">
      <Header rid={researcher.rid} />

      <div className="research-page">
        {/* ================= PROFILE ================= */}
        <section className="research-profile">
          {/* รูปโปรไฟล์ */}
          <div className="profile-image-box">
            <img
              src={xURL + "file_research/" + researcher.picname}
              alt="Profile"
              className="profile-image"
            />
          </div>

          {/* ข้อมูล */}
          <div className="profile-content">
            <h1>
              {researcher.name}
            </h1>

            <div className="profile-position">
              {(() => {
                let positionStr = `${researcher.position ||
                  ""} ${researcher.position_aca || ""}`.trim();
                if (researcher.positionex) {
                  positionStr = `${positionStr} | ${researcher.positionex}`;
                }
                return positionStr;
              })()}
            </div>

            {/* ความเชี่ยวชาญ */}
            <div className="expertise-row">
              <span className="expertise-title">ความเชี่ยวชาญ</span>
              {(() => {
                let expertise = [];
                if (researcher.researcher_expertise_thai_new) {
                  expertise = researcher.researcher_expertise_thai_new
                    .trim()
                    .replace(/^\|/, "")
                    .trim()
                    .split(/\|/)
                    .filter(e => e.trim().length > 0)
                    .map(e => e.trim());
                } else {
                  expertise = ["-"];
                }
                return expertise.map((exp, idx) =>
                  <span key={idx} className="expertise-tag">
                    {exp}
                  </span>
                );
              })()}
            </div>

            {/* Email */}
            <div className="email-box">
              <span className="email-icon">✉</span>

              <span>
                {researcher.email}
              </span>
            </div>

            {/* Scopus */}
            <div className="scopus-box">
              <span className="scopus-title">Scopus</span>
              <a
                href={researcher.h_index_link}
                target="_blank"
                rel="noopener noreferrer"
                className="scopus-text"
              >
                : Scopus Profile(h-index)
              </a>
            </div>

            <div className="scopus-detail">
              Scopus Author ID : {researcher.scopus_id || "-"}
            </div>

            <div className="orcid-detail">
              ORCID : <span>{researcher.ORCID || "-"}</span>
            </div>
          </div>
        </section>

        {/* เส้นคั่น */}
        <div className="profile-divider" />

        {/* ================= MENU ================= */}

        <section className="research-menu">
          {MENU_ITEMS.map(item =>
            <div
              key={item.id}
              className={`research-menu-item ${activeMenu === item.id
                ? "active"
                : ""}`}
              onClick={() => setActiveMenu(item.id)}
              style={{ cursor: "pointer" }}
            >
              <div className="menu-icon">
                {item.icon}
              </div>
              <div>
                {item.label}
              </div>
            </div>
          )}
        </section>

        {/* ================= CONTENT ================= */}
        <section className="research-content">
          {activeMenu === 1 &&
            <div className="research-highlight">
              <div className="research-title">
                <h2>Research Highlight</h2>

                <div className="research-content-line" />
              </div>

              <article className="highlight-card">
                <div className="highlight-header">
                  <h2>
                    {researcher.topic_name_th || "-"}
                  </h2>
                </div>

                <div className="highlight-top">
                  <div className="highlight-image">
                    {researcher.topic_pic1
                      ? <img
                          src={
                            xURL +
                            "file_research_topic/" +
                            researcher.topic_pic1
                          }
                          alt="Research Highlight"
                          className="highlight-img"
                          style={{
                            cursor: "pointer",
                            maxWidth: "100%",
                            height: "auto"
                          }}
                          onClick={() =>
                            setEnlargedImage(
                              xURL +
                                "file_research_topic/" +
                                researcher.topic_pic1
                            )}
                        />
                      : <div
                          style={{
                            width: "100%",
                            height: "500px",
                            backgroundColor: "#f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "8px",
                            fontSize: "48px"
                          }}
                        >
                          📷
                        </div>}
                  </div>

                  <div className="highlight-image">
                    {researcher.topic_pic2
                      ? <img
                          src={
                            xURL +
                            "file_research_topic/" +
                            researcher.topic_pic2
                          }
                          alt="Research Highlight"
                          className="highlight-img"
                          style={{
                            cursor: "pointer",
                            maxWidth: "100%",
                            height: "auto"
                          }}
                          onClick={() =>
                            setEnlargedImage(
                              xURL +
                                "file_research_topic/" +
                                researcher.topic_pic2
                            )}
                        />
                      : <div
                          style={{
                            width: "100%",
                            height: "500px",
                            backgroundColor: "#f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "8px",
                            fontSize: "48px"
                          }}
                        >
                          📷
                        </div>}
                  </div>
                </div>

                {enlargedImage &&
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.8)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2000,
                      cursor: "pointer"
                    }}
                    onClick={() => setEnlargedImage(null)}
                  >
                    <div
                      style={{
                        maxWidth: "80vw",
                        maxHeight: "80vh",
                        position: "relative",
                        animation: "fadeIn 0.3s ease-in"
                      }}
                      onClick={e => e.stopPropagation()}
                    >
                      <img
                        src={enlargedImage}
                        alt="enlarged"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "8px",
                          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)"
                        }}
                      />
                      <button
                        onClick={() => setEnlargedImage(null)}
                        style={{
                          position: "absolute",
                          top: "-40px",
                          right: "0",
                          background: "white",
                          border: "none",
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          fontSize: "24px",
                          cursor: "pointer",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  </div>}

                <div className="highlight-detail">
                  {researcher.topic_detail_th
                    ? <div>
                        {researcher.topic_detail_th
                          .split(/\n\n+/)
                          .map((paragraph, idx) =>
                            <p key={idx}>
                              {paragraph}
                            </p>
                          )}
                      </div>
                    : <p className="no-data">
                        ยังไม่มีข้อมูล Research Highlight
                      </p>}
                </div>
              </article>
            </div>}

          {activeMenu === 2 &&
            <div>
              <div className="research-title">
                <h2>Field of Research</h2>

                <div className="research-content-line" />
              </div>
              <article className="highlight-card">
                <div className="research-topics">
                  {researcher.research_topic_thai_new
                    ? <ul>
                        {researcher.research_topic_thai_new
                          .trim()
                          .replace(/^\|/, "")
                          .trim()
                          .split(/\|/)
                          .filter(e => e.trim().length > 0)
                          .map((topic, idx) =>
                            <li key={idx}>
                              {topic.trim()}
                            </li>
                          )}
                      </ul>
                    : <p className="no-data">
                        ยังไม่มีข้อมูล Field of Research
                      </p>}
                </div>
              </article>
            </div>}

          {activeMenu === 3 &&
            <div>
              <div className="research-title">
                <h2>Publication</h2>

                <div className="research-content-line" />
              </div>
              <article className="highlight-card">
                <div className="publication-header">
                  <h3>
                    ผลงานตีพิมพ์ใน Scopus จำนวน{" "}
                    {publications ? publications.length : "0"} เรื่อง
                  </h3>
                </div>

                <div className="publication-table-wrapper">
                  <table className="publication-table">
                    <thead>
                      <tr>
                        <th width="5%" style={{ textAlign: "center" }}>
                          ที่
                        </th>
                        <th width="50%">ชื่อเรื่อง</th>
                        <th width="10%" style={{ textAlign: "center" }}>
                          ปี
                        </th>
                        <th width="25%">ชื่อวารสาร</th>
                        <th width="10%" style={{ textAlign: "center" }}>
                          SJR
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentPublications && currentPublications.length > 0
                        ? currentPublications.map((pub, idx) =>
                            <tr key={idx}>
                              <td align="center">
                                {startIdx + idx + 1}
                              </td>
                              <td className="publication-title">
                                <a
                                  href={pub.url || pub.link || "#"}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="publication-link"
                                >
                                  {pub.title || "-"}
                                </a>
                              </td>
                              <td align="center">
                                {pub.year || "-"}
                              </td>
                              <td>
                                {pub.journal_name || "-"}
                              </td>
                              <td align="center">
                                {pub.sjr_q || "-"}
                              </td>
                            </tr>
                          )
                        : <tr>
                            <td colSpan="5" className="no-data">
                              ยังไม่มีข้อมูล Publication
                            </td>
                          </tr>}
                    </tbody>
                  </table>
                </div>

                <div className="publication-pagination">
                  <div className="pagination-info">
                    <p>
                      แสดง{" "}
                      {publications && publications.length > 0
                        ? startIdx + 1
                        : 0}{" "}
                      -{" "}
                      {Math.min(
                        endIdx,
                        publications ? publications.length : 0
                      )}{" "}
                      จาก {publications ? publications.length : 0} เรื่อง
                    </p>
                  </div>

                  {totalPages > 1 &&
                    <div className="pagination-buttons">
                      <button
                        className="pagination-btn"
                        onClick={() =>
                          setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        ← ก่อนหน้า
                      </button>

                      <div className="pagination-pages">
                        {Array.from(
                          { length: totalPages },
                          (_, i) => i + 1
                        ).map(page =>
                          <button
                            key={page}
                            className={`pagination-page ${currentPage === page
                              ? "active"
                              : ""}`}
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </div>

                      <button
                        className="pagination-btn"
                        onClick={() =>
                          setCurrentPage(prev =>
                            Math.min(prev + 1, totalPages)
                          )}
                        disabled={currentPage === totalPages}
                      >
                        ถัดไป →
                      </button>
                    </div>}
                </div>
              </article>
            </div>}

          {activeMenu === 4 &&
            <div>
              <div className="research-title">
                <h2>Projects</h2>
                <div className="research-content-line" />
              </div>

              <article className="highlight-card">
                <div className="publication-table-wrapper">
                  <table className="publication-table">
                    <thead>
                      <tr>
                        <th width="5%" style={{ textAlign: "center" }}>
                          ที่
                        </th>
                        <th width="40%">ชื่อโครงการ</th>
                        <th width="25%">แหล่งทุน</th>
                        {/* <th width="10%" style={{ textAlign: "center" }}>
                          วันที่เริ่มต้นโครงการ
                        </th> */}
                        <th width="20%" style={{ textAlign: "center" }}>
                          สถานะการดำเนินงาน
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentHeadProjects && currentHeadProjects.length > 0
                        ? (() => {
                            const startRowNumber =
                              countPreviousRows(headProjects, headProjectsStartIdx) + 1;
                            let rowNumber = startRowNumber;
                            return currentHeadProjects.map((pub, idx) => {
                              const shouldRender =
                                idx === 0 ||
                                currentHeadProjects[idx].name_thai !==
                                  currentHeadProjects[idx - 1].name_thai;

                              const rowSpan = (() => {
                                let count = 1;
                                for (
                                  let i = idx + 1;
                                  i < currentHeadProjects.length;
                                  i++
                                ) {
                                  if (
                                    currentHeadProjects[i].name_thai ===
                                    pub.name_thai
                                  ) {
                                    count++;
                                  } else {
                                    break;
                                  }
                                }
                                return count;
                              })();

                              const tr = (
                                <tr key={idx}>
                                  {shouldRender &&
                                    <td
                                      rowSpan={rowSpan}
                                      style={{ textAlign: "center" }}
                                    >
                                      {rowNumber}
                                    </td>}
                                  {shouldRender &&
                                    <td rowSpan={rowSpan}>
                                      {pub.name_thai || "-"}
                                    </td>}
                                  <td>
                                    {pub.agency_name || "-"}
                                  </td>

                                  {/* {shouldRender &&
                                    <td rowSpan={rowSpan} align="center">
                                      {formatDateDDMMYYYY(pub.start_date)}
                                    </td>} */}

                                  {shouldRender &&
                                    <td
                                      rowSpan={rowSpan}
                                      style={{ textAlign: "center" }}
                                    >
                                      {(() => {
                                        const status = getStatusStyle(
                                          pub.status_id
                                        );
                                        return (
                                          <div
                                            style={{
                                              display: "inline-block",
                                              padding: "6px 12px",
                                              backgroundColor: status.bgColor,
                                              color: status.color,
                                              borderRadius: "20px",
                                              fontSize: "13px",
                                              fontWeight: "500",
                                              whiteSpace: "nowrap"
                                            }}
                                          >
                                            <span
                                              style={{ marginRight: "6px" }}
                                            >
                                              {status.icon}
                                            </span>
                                            {status.label}
                                          </div>
                                        );
                                      })()}
                                    </td>}
                                </tr>
                              );

                              if (shouldRender) {
                                rowNumber++;
                              }

                              return tr;
                            });
                          })()
                        : [
                            <tr>
                              <td colSpan="4" className="no-data">
                                ยังไม่มีข้อมูล Projects
                              </td>
                            </tr>
                          ]}
                    </tbody>
                  </table>
                </div>

                <div className="publication-pagination">
                  <div className="pagination-info">
                    <p>
                      แสดง{" "}
                      {currentHeadProjects && currentHeadProjects.length > 0
                        ? countPreviousRows(headProjects, headProjectsStartIdx) + 1
                        : 0}{" "}
                      -{" "}
                      {countPreviousRows(headProjects, headProjectsStartIdx) +
                        countDistinctRows(currentHeadProjects)}{" "}
                      จาก {countDistinctRows(headProjects)} เรื่อง
                    </p>
                  </div>

                  {totalPages2 > 1 &&
                    <div className="pagination-buttons">
                      <button
                        className="pagination-btn"
                        onClick={() =>
                          setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        ← ก่อนหน้า
                      </button>

                      <div className="pagination-pages">
                        {Array.from(
                          { length: totalPages2 },
                          (_, i) => i + 1
                        ).map(page =>
                          <button
                            key={page}
                            className={`pagination-page ${currentPage === page
                              ? "active"
                              : ""}`}
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </div>

                      <button
                        className="pagination-btn"
                        onClick={() =>
                          setCurrentPage(prev =>
                            Math.min(prev + 1, totalPages2)
                          )}
                        disabled={currentPage === totalPages2}
                      >
                        ถัดไป →
                      </button>
                    </div>}
                </div>
              </article>
            </div>}

          {activeMenu === 5 &&
            <div>
              <div className="research-title">
                <h2>Patent</h2>
                <div className="research-content-line" />
              </div>

              <article className="highlight-card">
                <div className="publication-table-wrapper">
                  <table className="publication-table">
                    <thead>
                      <tr>
                        <th width="5%" style={{ textAlign: "center" }}>
                          ที่
                        </th>
                        <th width="60%">
                          ชื่อที่แสดงถึงการประดิษฐ์/การออกแบบผลิตภัณฑ์
                        </th>
                        <th width="35%" style={{ textAlign: "center" }}>
                          ประเภท
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentPatents && currentPatents.length > 0
                        ? currentPatents.map((pub, idx) =>
                            <tr key={idx}>
                              <td align="center">
                                {startIdx + idx + 1}
                              </td>
                              <td>
                                {pub.patent_name || "-"}
                              </td>
                              <td align="center">
                                {getPatentType(pub.patent_type)}
                              </td>
                            </tr>
                          )
                        : <tr>
                            <td colSpan="3" className="no-data">
                              ยังไม่มีข้อมูล Patent
                            </td>
                          </tr>}
                    </tbody>
                  </table>
                </div>

                <div className="publication-pagination">
                  <div className="pagination-info">
                    <p>
                      แสดง{" "}
                      {currentPatents && currentPatents.length > 0
                        ? startIdx + 1
                        : 0}{" "}
                      -{" "}
                      {Math.min(
                        endIdx,
                        currentPatents ? currentPatents.length : 0
                      )}{" "}
                      จาก {currentPatents ? currentPatents.length : 0} เรื่อง
                    </p>
                  </div>

                  {totalPages3 > 1 &&
                    <div className="pagination-buttons">
                      <button
                        className="pagination-btn"
                        onClick={() =>
                          setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        ← ก่อนหน้า
                      </button>

                      <div className="pagination-pages">
                        {Array.from(
                          { length: totalPages3 },
                          (_, i) => i + 1
                        ).map(page =>
                          <button
                            key={page}
                            className={`pagination-page ${currentPage === page
                              ? "active"
                              : ""}`}
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </div>

                      <button
                        className="pagination-btn"
                        onClick={() =>
                          setCurrentPage(prev =>
                            Math.min(prev + 1, totalPages3)
                          )}
                        disabled={currentPage === totalPages3}
                      >
                        ถัดไป →
                      </button>
                    </div>}
                </div>
              </article>
            </div>}

          {activeMenu === 6 &&
            <div>
              <div className="research-title">
                <h2>Awards</h2>
                <div className="research-content-line" />
              </div>
              <article className="highlight-card">
                <div className="publication-table-wrapper">
                  <table className="publication-table">
                    <thead>
                      <tr>
                        <th width="5%" style={{ textAlign: "center" }}>
                          ที่
                        </th>
                        <th width="70%">รางวัล</th>
                        <th width="25%" style={{ textAlign: "center" }}>
                          ปี
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentAwards && currentAwards.length > 0
                        ? currentAwards.map((pub, idx) =>
                            <tr key={idx}>
                              <td align="center">
                                {startIdx + idx + 1}
                              </td>
                              <td>
                                {pub.award_description_thai || "-"}
                              </td>
                              <td align="center">
                                {pub.award_year || "-"}
                              </td>
                            </tr>
                          )
                        : <tr>
                            <td colSpan="3" className="no-data">
                              ยังไม่มีข้อมูล Awards
                            </td>
                          </tr>}
                    </tbody>
                  </table>
                </div>

                <div className="publication-pagination">
                  <div className="pagination-info">
                    <p>
                      แสดง{" "}
                      {currentAwards && currentAwards.length > 0
                        ? startIdx + 1
                        : 0}{" "}
                      -{" "}
                      {Math.min(
                        endIdx,
                        currentAwards ? currentAwards.length : 0
                      )}{" "}
                      จาก {currentAwards ? currentAwards.length : 0} เรื่อง
                    </p>
                  </div>

                  {totalPages4 > 1 &&
                    <div className="pagination-buttons">
                      <button
                        className="pagination-btn"
                        onClick={() =>
                          setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        ← ก่อนหน้า
                      </button>

                      <div className="pagination-pages">
                        {Array.from(
                          { length: totalPages4 },
                          (_, i) => i + 1
                        ).map(page =>
                          <button
                            key={page}
                            className={`pagination-page ${currentPage === page
                              ? "active"
                              : ""}`}
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </div>

                      <button
                        className="pagination-btn"
                        onClick={() =>
                          setCurrentPage(prev =>
                            Math.min(prev + 1, totalPages4)
                          )}
                        disabled={currentPage === totalPages4}
                      >
                        ถัดไป →
                      </button>
                    </div>}
                </div>
              </article>
            </div>}
        </section>

        {/* เส้นคั่น */}
        <div className="profile-divider" />
      </div>
    </div>
  );
};

export default Research_rihes_detail_th;
